<template>
    <div>
        <vue-snotify></vue-snotify>
        <loading :active.sync="isLoading" :is-full-page="fullPage" :loader="$store.state.spinerLoader"
            :color="$store.state.spinerColor"></loading>

        <div class="header pb-8 pt-4">
            <b-container fluid>
                <span class="mask bg-info "></span>
            </b-container>
        </div>

        <b-container fluid class="mt--6">
            <b-row>
                <b-col cols="6">
                    <b-card>
                        <label class="mt-2">Workflow name</label>
                        <b-form-input class="w-100" v-model="workflowName" placeholder="workflow name"
                            :rules="{ required: true }"></b-form-input>

                        <label class="mt-2">The first reviewer</label>
                        <b-form-select class="w-100" :options="users" v-model="firstReviewer">
                        </b-form-select>

                        <label class="mt-2">The second reviewer</label>
                        <b-form-select class="w-100" :options="users" v-model="secondReviewer"></b-form-select>

                        <b-button class="mt-3" @click="addWorkflow()" variant="outline-success">Add workflow</b-button>

                        <b-row class="mt-3">
                            <b-col cols="12">
                                <vuetable ref="workflowTable" :api-mode="false" :fields="workFlowsFields"
                                    :per-page="workFlowsPerPage" :data-manager="dataManagerWorkflowTable"
                                    pagination-path="pagination"
                                    @vuetable:pagination-data="onPaginationDataWorkflowTable">
                                    <template slot="actions" scope="props">
                                        <div style="text-align: center;">
                                            <i class="fa-solid fa-trash iconDelete"
                                                @click="deleteWorkflow(props.rowData.id)"></i>
                                        </div>
                                    </template>
                                </vuetable>
                            </b-col>
                            <b-col cols="12" class="pt-2">
                                <vuetable-pagination-info ref="paginationInfonWorkflowTable"></vuetable-pagination-info>

                                <vuetable-pagination class="float-right" ref="paginationWorkflowTable"
                                    @vuetable-pagination:change-page="onChangePageWorkflowTable"></vuetable-pagination>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
                <b-col cols="6">
                    <b-card>
                        <label class="mt-2">User</label>
                        <b-form-select class="w-100" :options="users" v-model="userForworkFlowId"></b-form-select>

                        <label class="mt-2">Review workflow</label>
                        <b-form-select class="w-100" :options="workFlowOptions" v-model="workFlowForUserId">
                        </b-form-select>

                        <b-button class="mt-3" @click="setWorkflowForUser()" variant="outline-success">Set workflow for
                            user</b-button>

                        <b-row class="mt-3">
                            <b-col cols="12">
                                <vuetable ref="userWorkflowTable" :api-mode="false" :fields="userWorkflowsFields"
                                    :per-page="userWorkflowPerPage" :data-manager="dataManagerUserWorkflowTable"
                                    pagination-path="pagination"
                                    @vuetable:pagination-data="onPaginationDataUserWorkflowTable">
                                    <template slot="actions" scope="props">
                                        <div style="text-align: center;">
                                            <i class="fa-solid fa-trash iconDelete"
                                                @click="deleteWorkflowUser(props.rowData.id)"></i>
                                        </div>
                                    </template>
                                </vuetable>
                            </b-col>
                            <b-col cols="12" class="pt-2">
                                <vuetable-pagination-info
                                    ref="paginationInfonUserWorkflowTable"></vuetable-pagination-info>

                                <vuetable-pagination class="float-right" ref="paginationUserWorkflowTable"
                                    @vuetable-pagination:change-page="onChangePageUserWorkflowTable"></vuetable-pagination>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>

import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "../../components/Vuetable/VuetablePaginationBootstrap4";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo.vue";

import mixins from "./../../mixins/common.js";
import "vue-select/dist/vue-select.css";
import { mapActions, mapState } from "vuex";
import _ from "lodash";

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
    },
    mixins: [mixins],
    data() {
        return {
            isLoading: false,
            fullPage: true,
            workflowName: "",
            users: [],
            firstReviewer: null,
            secondReviewer: null,
            workFlows: [],
            workFlowOptions: [],
            workFlowForUserId: null,
            userForworkFlowId: null,
            workflowUser: [],
            workFlowsFields: [
                {
                    name: "workflowName",
                    title: 'Name',
                    width: "50%"
                },
                {
                    name: "firstReviewer.firstName",
                    title: 'The First Reviewer',
                    width: "50%"
                },
                {
                    name: "secondReviewer.firstName",
                    title: 'The Second Reviewer',
                    width: "50%"
                },
                {
                    name: "actions",
                    title: ''
                }
            ],
            workFlowsPerPage: 10,
            userWorkflowsFields: [
                {
                    name: "userName",
                    title: 'User',
                    width: "50%"
                },
                {
                    name: "workflowName",
                    title: 'Workflow',
                    width: "50%"
                },
                {
                    name: "actions",
                    title: ''
                }
            ],
            userWorkflowPerPage: 10
        }
    },
    mounted() {
        this.isLoading = true;
        this.getAllUsers().then((data) => {
            for (let i = 0; i < data.data.length; i++) {
                this.users.push({ value: data.data[i].id, text: data.data[i].firstName });
            }
            this.isLoading = false;
        });
        this.getWorkflows();
        this.getWorkflowUserRequest();
    },
    methods: {
        ...mapActions("admin", ["createReviewWorkflow", "getAllUsers", "getReviewWorkflows", "deleteReviewWorkflow", "setWorkflowUser", "getWorkflowUser", "deleteWorkflowUserRequest"]),
        addWorkflow() {
            if (this.workflowName.trim().length > 0) {
                this.isLoading = true;
                this.createReviewWorkflow({ name: this.workflowName, firstReviewId: this.firstReviewer, secondReviewId: this.secondReviewer }).then(() => {
                    this.isLoading = false;
                    this.workflowName = "";
                    this.firstReviewer = null;
                    this.secondReviewer = null;
                    this.getWorkflows();
                });
            }

        },
        getWorkflows: function () {
            this.getReviewWorkflows().then((data) => {
                this.workFlows = data.data;
                this.$refs.workflowTable.refresh();
                this.workFlowOptions = [];
                for (let i = 0; i < data.data.length; i++) {
                    this.workFlowOptions.push({ value: data.data[i].id, text: data.data[i].workflowName });
                }
            });
        },
        getWorkflowUserRequest: function () {
            this.getWorkflowUser().then((data) => {
                this.workflowUser = [];
                for (let i = 0; i < data.data.length; i++) {
                    this.workflowUser.push({ id: data.data[i].id, userName: data.data[i].user.firstName, workflowName: data.data[i].workflow.workflowName });
                }
                this.$refs.userWorkflowTable.refresh();
            });
        },
        deleteWorkflow: function (id) {
            this.deleteReviewWorkflow(id).then((data) => {
                this.getWorkflows();
            });
        },
        setWorkflowForUser: function () {
            if (this.workFlowForUserId && this.userForworkFlowId) {
                this.setWorkflowUser({ workflowId: this.workFlowForUserId, userId: this.userForworkFlowId }).then((data) => {
                    this.userForworkFlowId = null;
                    this.workFlowForUserId = null;
                    this.getWorkflowUserRequest();
                });
            }
        },
        deleteWorkflowUser: function (id) {
            this.deleteWorkflowUserRequest(id).then((data) => {
                this.getWorkflowUserRequest();
            })
        },
        //WorkflowTable
        onChangePageWorkflowTable(page) {
            this.$refs.workflowTable.changePage(page);
        },
        onPaginationDataWorkflowTable(paginationData) {
            this.$refs.paginationWorkflowTable.setPaginationData(paginationData);
            this.$refs.paginationInfonWorkflowTable.setPaginationData(paginationData);
        },
        dataManagerWorkflowTable(sortOrder, pagination) {
            let local = this.workFlows;

            pagination = this.$refs.workflowTable.makePagination(
                local.length,
                this.workFlowsPerPage
            );

            // sortOrder can be empty, so we have to check for that as well
            if (sortOrder.length > 0) {
                local = _.orderBy(
                    local,
                    sortOrder[0].sortField,
                    sortOrder[0].direction
                );
            }

            let from = pagination.from - 1;
            let to = from + this.workFlowsPerPage;
            return {
                pagination: pagination,
                data: _.slice(local, from, to),
            };
        },
        //UserWorkflowTable
        onChangePageUserWorkflowTable(page) {
            this.$refs.userWorkflowTable.changePage(page);
        },
        onPaginationDataUserWorkflowTable(paginationData) {
            this.$refs.paginationUserWorkflowTable.setPaginationData(paginationData);
            this.$refs.paginationInfonUserWorkflowTable.setPaginationData(paginationData);
        },
        dataManagerUserWorkflowTable(sortOrder, pagination) {
            let local = this.workflowUser;

            pagination = this.$refs.userWorkflowTable.makePagination(
                local.length,
                this.userWorkflowPerPage
            );

            // sortOrder can be empty, so we have to check for that as well
            if (sortOrder.length > 0) {
                local = _.orderBy(
                    local,
                    sortOrder[0].sortField,
                    sortOrder[0].direction
                );
            }

            let from = pagination.from - 1;
            let to = from + this.userWorkflowPerPage;
            return {
                pagination: pagination,
                data: _.slice(local, from, to),
            };
        },
    }
}
</script>

<style scoped>
.iconDelete {
    cursor: pointer;
}
</style>